import { connect } from "react-redux";
import { PageContactUs } from "senac-components";
import {
  PageContactUsDispatchProps,
  PageContactUsStateProps,
  ContactUsForm,
} from "senac-components/dist/pages/Mobile/PageContactUs";

import { AppDispatch, RootState } from "../store";
import { commonSlice, contentSlice, userSlice } from "../store/reducers";
import {
  ContentHeaderOptionItem,
  MenuOptions,
  PageHeaderOptionItem,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import { PageContactUsWeb } from "senac-components/dist/pages/Web/PageContactUs";

type StateProps = {
  loading: boolean;
  authenticatedUser: boolean;
  initialParams?: {
    email: string;
    name: string;
  }
  clearForm?: boolean;
}

const mapState = (state: RootState) => {
  const authenticatedUser = state.userState.user != undefined;

  let result: StateProps = {
    loading: state.userState.contactLoading,
    authenticatedUser,
    initialParams: {
      email: state.userState.user?.email ?? '',
      name: state.userState.user?.name ?? '',
    },
    clearForm: state.userState.clearContactForm
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => {
  const result: PageContactUsDispatchProps = {
    onSubmitContactUs: (contactUsForm: ContactUsForm) =>
      dispatch(userSlice.actions.contactUs(contactUsForm)),
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: ContentHeaderOptionItem) =>
      dispatch(commonSlice.actions.goToMyProfileOption(option)),
    onSelectedNavigationPageOption: (option: MenuOptions) =>
      dispatch(commonSlice.actions.goToPage(option)),
  };

  return result;
};

const WPageContactUs = () => {
  const Web = connect(mapState, mapDispatch)(PageContactUsWeb);
  const Mobile = connect(mapState, mapDispatch)(PageContactUs);
  if(window.innerWidth >= 1024) return <Web />
  return <Mobile />
}

export { WPageContactUs };
